export const categories = [
  {
    id: "career",
    name: "职场生涯",
    slug: "career",
    icon: "ri-briefcase-line",
    description: "第一次面试、第一次入职、第一次汇报——职场中的每一个「第一次」，都是成长的阶梯。",
    color: "primary",
  },
  {
    id: "relationship",
    name: "人际情感",
    slug: "relationship",
    icon: "ri-heart-line",
    description: "第一次约会、第一次表白、第一次见家长——情感世界里，每个「第一次」都值得被温柔对待。",
    color: "accent",
  },
  {
    id: "life",
    name: "生活成长",
    slug: "life",
    icon: "ri-home-smile-line",
    description: "第一次独立租房、第一次做饭、第一次理财——生活的每一个「第一次」，都是独立宣言。",
    color: "secondary",
  },
  {
    id: "study",
    name: "学习进阶",
    slug: "study",
    icon: "ri-book-open-line",
    description: "第一次公开演讲、第一次考试、第一次写论文——学海无涯，每个「第一次」都是新的起点。",
    color: "primary",
  },
  {
    id: "social",
    name: "社交场合",
    slug: "social",
    icon: "ri-group-line",
    description: "第一次参加派对、第一次主持活动、第一次社交破冰——社交达人的第一步从这里开始。",
    color: "accent",
  },
  {
    id: "travel",
    name: "旅行探险",
    slug: "travel",
    icon: "ri-compass-3-line",
    description: "第一次独自旅行、第一次出国、第一次露营——世界很大，带着勇气出发吧。",
    color: "secondary",
  },
];

export const categoryColorMap: Record<string, string> = {
  career: "primary",
  relationship: "accent",
  life: "secondary",
  study: "primary",
  social: "accent",
  travel: "secondary",
};